export const ValidationErrors = Object.freeze({
	warehouseRequired: 'Warehouse is required',
	purchaseOrderMaxChar: 'PO# must contain less than 255 characters',
	referenceMaxChar: 'Reference must contain less than 255 characters',
	packingMethodRequired: 'Packing Method is required',
	shippingMethodRequired: 'Shipping Method is required',
	productRequired: 'Product is required',
	quantityRequired: 'Product quantity is required',
	quantityZero: 'Product quantity must be greater than 0',
	barcodeRequired: 'Barcode is required',
	barcodeDuplicate: 'This barcode is already in use. Please provide a unique barcode.',
	estimatedArrivalRequired: 'Estimated Arrival is required',
	estimatedArrivalPast: 'Estimated Arrival cannot be in the past',
	shipFromRequired: 'Ship From address is required',
	trackingNumberMax: 'Tracking Number must be less than 255 characters',
	weightMax: 'Weight cannot exceed 150 lbs',
	weightZero: 'Weight cannot be 0',
	lengthMax: 'This package is too long to ship with UPS. Length cannot exceed 108',
	dimensionsMax:
		'This package is too large to ship with UPS. Length + 2x width + 2x height cannot exceed 165',
	termsCheckboxRequired: 'Must agree to the Zorbit Terms of Service',
});

export default class Validation {}
